import { Editor } from "@tiptap/core";
import { Markdown } from "@tiptap/markdown";
import type { Content, Extensions } from "@tiptap/react";
import { extensions, parseTiptapContent } from "./TipTap";

const createMarkdownEditor = (content: Content, baseExtensions: Extensions) =>
  new Editor({
    extensions: [...baseExtensions, Markdown],
    content,
  });

function stripNbspFromEmptyParagraphs(node: Record<string, unknown>): Record<string, unknown> {
  if (
    node.type === "paragraph" &&
    Array.isArray(node.content) &&
    node.content.length === 1 &&
    (node.content[0] as Record<string, unknown>).type === "text" &&
    ((node.content[0] as Record<string, unknown>).text === "&nbsp;" ||
      (node.content[0] as Record<string, unknown>).text === "\u00A0")
  ) {
    return { ...node, content: [] };
  }
  if (Array.isArray(node.content)) {
    return { ...node, content: node.content.map((child) => stripNbspFromEmptyParagraphs(child as Record<string, unknown>)) };
  }
  return node;
}

export const getMarkdownFromTiptapContent = (content: string, baseExtensions: Extensions = extensions) => {
  const editor = createMarkdownEditor((parseTiptapContent(content) ?? "") as Content, baseExtensions);
  let markdown = editor.getMarkdown();
  editor.destroy();
  // Strip &nbsp; emitted by Paragraph extension for empty paragraphs.
  // The table extension's parseMarkdown bypasses the paragraph handler's
  // &nbsp;-stripping logic, so these leak as literal text on re-import.
  markdown = markdown.replace(/&nbsp;/g, "");
  return markdown;
};

export const getTiptapJsonFromMarkdown = (markdown: string, baseExtensions: Extensions = extensions) => {
  const editor = createMarkdownEditor("", baseExtensions);
  editor.commands.setContent(markdown, { contentType: "markdown" });
  const json = stripNbspFromEmptyParagraphs(editor.getJSON() as Record<string, unknown>);
  editor.destroy();
  return JSON.stringify(json);
};
